document.addEventListener('DOMContentLoaded', function() {
  var equipInput = document.getElementById('equipmentCost');
  var printsInput = document.getElementById('dailyPrints');
  var chargeInput = document.getElementById('extraCharge');

  if (!equipInput || !printsInput || !chargeInput) return;

  function updateROI() {
    var equipCost = parseFloat(equipInput.value) || 698;
    var daily = parseInt(printsInput.value);
    var charge = parseFloat(chargeInput.value);

    document.getElementById('dailyPrintsValue').textContent = daily;
    document.getElementById('extraChargeValue').textContent = '$' + charge.toFixed(2);

    var inkPerPrint = 0.0197;
    var dailyInk = daily * inkPerPrint;
    var dailyRev = daily * charge;
    var dailyNet = dailyRev - dailyInk;
    var paybackDays = dailyNet > 0 ? Math.ceil(equipCost / dailyNet) : '∞';
    var monthlyNet = dailyNet * 30;

    document.getElementById('dailyInkCost').textContent = '$' + dailyInk.toFixed(2);
    document.getElementById('dailyRevenue').textContent = '$' + dailyRev.toFixed(2);
    document.getElementById('dailyProfit').textContent = '$' + dailyNet.toFixed(2);
    document.getElementById('paybackPeriod').textContent = '~' + paybackDays + ' days';
    document.getElementById('monthlyProfit').textContent = '$' + monthlyNet.toFixed(2);
  }

  equipInput.addEventListener('input', updateROI);
  printsInput.addEventListener('input', updateROI);
  chargeInput.addEventListener('input', updateROI);

  updateROI();
});